export default () => ({
  usersData: undefined,
});